module.exports = __webpack_public_path__ + "static/sty-4e588c7b132079458a98774832e7ad1c.png";